/* Built In Imports */

/* External Imports */
import { Box, Image } from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import LazyImageRenderComponent from '@components/UI/LazyImageRenderComponent';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const IEOVenuePartners = ({ sectionContent, lang }) => {
  return (
    <>
      <Box
        mt={'0px'}
        maxW={'1164px'}
        mx="auto"
        py={{ base: '0px' }}
        px={{ base: '16px', md: '16px' }}
        textAlign={'center'}
        className="ieo-program-fees-info"
        color={'#000000'}
        mb={{ base: '79px', md: '80px', lg: '149px' }}
      >
        <StructuredTextParser
          textAlign={{ base: 'left', md: 'center' }}
          fontSize={{ base: '32px', md: '64px' }}
          lineHeight={{ base: '38px', md: '64px' }}
          mb={{ base: '33px', md: '80px' }}
          color={{ base: '#3B444B', md: '#3B444B' }}
          fontWeight={{ base: '500', md: '500' }}
          str={sectionContent?.[0].titleText}
          fontFamily="FedraSansStd-medium"
          maxW="auto"
          mt="0px"
        />
        <Box
          display={'grid'}
          gridTemplateColumns={{
            base: '1fr 1fr',
            md: '1fr 1fr 1fr',
            xl: '1fr 1fr 1fr 1fr',
          }}
          rowGap={'24px'}
          columnGap={'10px'}
        >
          {sectionContent?.[1].images?.map(el => (
            <LazyImageRenderComponent
              alt={el?.alt || el?.title || ''}
              height="auto"
              objectFit="contain"
              bgPos="center"
              borderRadius="0"
              src={el?.url}
              w={'100%'}
              maxH={'164px'}
            />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default IEOVenuePartners;
